/**
 * Who performed a session-scoped order action (start, call, complete, cancel, snooze, etc.).
 */
export interface OrderActorRef {
  tenantUserId: string;
  sessionMemberId?: string | null;
  workspaceMemberId?: string | null;
  /** Set by orders actions API when enriching the payload for display. */
  displayName?: string | null;
}

export function orderActorTenantUserId(ref: OrderActorRef | null | undefined): string | null {
  if (ref == null || !ref.tenantUserId) return null;
  return ref.tenantUserId;
}

export function orderActorPresent(ref: OrderActorRef | null | undefined): boolean {
  return orderActorTenantUserId(ref) != null;
}
